import styled from "styled-components";
import { ReactComponent as ChevronSvg } from "../../assets/icons/chevronLeft.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  flex: 1;
`;

export const Chevron = styled(ChevronSvg)`
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
  white-space: nowrap;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #0b1727;
  /* min-height: 362px; */

  display: flex;

  padding: 12px;
  padding-bottom: ${(props) => (props.$open ? "12px" : "3px")};
  transition: all 0.4s ease-in-out;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
`;
export const DateLabelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const DateLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;

  .chevron {
    rotate: ${(props) => (!props.$open ? "-90deg" : "90deg")};
    transition: rotate 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.02);
    transition: background 0.2s ease;
  }
`;
export const DateLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.24px;
`;
export const PodiumGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 825px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const PodiumCard = styled.div`
  border-radius: 20px;

  background: ${(props) =>
    props.$rank === 1
      ? "linear-gradient(213deg, #ffbd25 6.81%, #d87b00 52.91%, #c58300 93.19%)"
      : props.$rank === 2
        ? "linear-gradient(213deg, #8E8E8E 6.81%, #A8A8A8 43.77%, #8E8E8E 93.19%)"
        : props.$rank === 3
          ? "linear-gradient(213deg, #823305 6.81%, #9F430B 43.77%, #893605 93.19%)"
          : "#142743"};

  box-shadow: ${(props) =>
    props.$rank === 1
      ? "0 12px 18px 0 rgba(239, 160, 21, 0.37), 0 1.6px 4px 0px #FFDB89 inset"
      : props.$rank === 2
        ? "0 1.6px 3px 0px #DADADA inset"
        : props.$rank === 3
          ? "0 1.6px 3px 0px #EEA14E inset"
          : "none"};

  border: ${(props) =>
    props.$rank === 1
      ? "2.4px solid #FB0"
      : props.$rank === 2
        ? "2.4px solid #AAA"
        : props.$rank === 3
          ? "2.4px solid #813205"
          : "0.5px solid #325682"};

  height: ${(props) =>
    props.$rank === 1
      ? "100px"
      : props.$rank === 2
        ? "80px"
        : props.$rank === 3
          ? "60px"
          : "44px"};

  width: 251px;

  display: flex;
  padding: 2px 44px 2px 25px;
  align-items: center;
  gap: 10px;
  @media (max-width: 350px) {
    width: 100%;
  }
`;

export const PodiumIcon = styled.div`
  @media (max-width: 350px) {
    svg {
      width: 40px;
      height: auto;
    }
  }
`;
export const PodiumColumn = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const PodiumRank = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.9px;
  opacity: 0.6;
`;

export const PodiumName = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.36px;
  text-transform: lowercase;
`;

export const LeaderboardGrid = styled.div`
  display: grid;
  gap: 16px;
  align-self: stretch;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 490px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;
export const LeaderboardContainer = styled.div`
  max-height: ${(props) =>
    props.$open
      ? `${props.$itemCount * 68 + 9 * (props.$itemCount - 1)}px`
      : "0px"};
  min-height: ${(props) => (props.$open ? "auto" : "0px")};
  overflow: hidden;
  transition:
    max-height 0.4s cubic-bezier(0.25, 0.8, 0.25, 1),
    padding-top 0.4s cubic-bezier(0.25, 0.8, 0.25, 1),
    gap 0.4s cubic-bezier(0.25, 0.8, 0.25, 1),
    min-height 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${(props) => (props.$open ? "9px" : "0px")};
  padding-top: ${(props) => (props.$open ? "9px" : "0px")};
  margin: 0;
  padding-bottom: 0;
`;

export const LeaderboardItem = styled.div`
  width: 100%;
  height: 44px;
  padding: ${(props) => (props.$open ? "12px" : "0px")};
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  display: flex;
  opacity: ${(props) => (props.$open ? 1 : 0)};
  transform: ${(props) =>
    props.$open ? "translateY(0)" : "translateY(-10px)"};
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-delay: ${(props) => (props.$open ? "0.1s" : "0s")};

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
`;
export const EarningContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const Earning = styled.span`
  color: #f2efe8;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
`;
export const LeaderboardRank = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.08px;
`;

export const LeaderboardName = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  text-transform: lowercase;
  letter-spacing: -0.21px;

  display: -webkit-box;
  -webkit-line-clamp: 1; /* Maksimalno 3 reda */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  gap: 16px;
`;
export const PopupContainer = styled.div`
  display: flex;
  max-width: 295px;
  padding: 12px;
  right: -295px;
  bottom: -80px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid #142743;
  background: #0b1727;
  position: absolute;
  z-index: 1000;

  opacity: ${(props) => (props.$isVisible ? "1" : "0")};
  transform: ${(props) =>
    props.$isVisible
      ? "translateY(0) scale(1)"
      : "translateY(-10px) scale(0.95)"};
  pointer-events: ${(props) => (props.$isVisible ? "all" : "none")};
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;

  @media (max-width: 565px) {
    right: 0;
    bottom: -106px;
  }
`;
export const PopupTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;
`;
export const PopupText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  opacity: 0.9;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  position: relative;
`;
export const Button = styled.button`
  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: 0.07px;
  cursor: pointer;
  border: none;
  outline: none;

  display: inline-flex;
  height: 40px;
  padding: 9px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  flex-shrink: 0;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }
`;
export const EmptyStateCard = styled.div`
  display: flex;
  width: 100%;
  /* max-width: 1107px; */
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const EmptyStateIcon = styled.div`
  font-size: 48px;
  margin-bottom: 20px;
  opacity: 0.6;
  display: flex;
  justify-content: center;
`;

export const EmptyStateTitle = styled.h3`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const EmptyStateText = styled.p`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.21px;
  opacity: 0.8;
`;

export const PublishButton = styled.button`
  display: flex;
  width: 180px;
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  border-radius: 100px;
  background: #fff;
  align-items: center;
  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 40px;
  padding: 20px;
  position: relative;
  z-index: 10;

  /* NOVO: Optimizacija */
  contain: layout style;
`;

export const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid ${(props) => (props.theme === "light" ? "#cbd5e0" : "#333")};
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${(props) => (props.theme === "light" ? "#2d3748" : "#fff")};

  /* NOVO: Optimizacija */
  will-change: background-color, border-color;
  backface-visibility: hidden;

  &:hover:not(:disabled) {
    background: ${(props) => (props.theme === "light" ? "#edf2f7" : "#333")};
    border-color: #2877d9;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ChevronIcon = styled.span`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.theme === "light" ? "#2d3748" : "#fff")};
`;

export const PagesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 16px;
`;

export const PageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 8px;
  border: 1px solid
    ${(props) => {
      if (props.theme === "light") {
        return props.$active ? "#2877D9" : "#cbd5e0";
      }
      return props.$active ? "#2877D9" : "#333";
    }};
  background: ${(props) => {
    if (props.theme === "light") {
      return props.$active ? "#2877D9" : "transparent";
    }
    return props.$active ? "#2877D9" : "transparent";
  }};
  color: ${(props) => {
    if (props.theme === "light") {
      return props.$active ? "#ffffff" : "#2d3748";
    }
    return props.$active ? "#000" : "#fff";
  }};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: Figtree;
  font-weight: 500;
  font-size: 14px;

  /* NOVO: Optimizacija */
  will-change: background-color, border-color;
  backface-visibility: hidden;

  &:hover:not(:disabled) {
    background: ${(props) => {
      if (props.theme === "light") {
        return props.$active ? "#2877D9" : "#edf2f7";
      }
      return props.$active ? "#2877D9" : "#333";
    }};
    border-color: #2877d9;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const Ellipsis = styled.span`
  color: ${(props) => (props.theme === "light" ? "#a0aec0" : "#666")};
  padding: 0 8px;
  font-family: Figtree;
  font-weight: 500;
`;

export const EmptyContainer = styled.div`
  /* box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5); */
  overflow: hidden;
  overflow-y: auto;
  max-width: fit-content;

  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  align-self: center;
  border-radius: 24px;

  @media (max-width: 768px) {
    max-width: 375px;
  }
  @media (max-width: 475px) {
    max-width: calc(100% - 32px);
  }
`;
export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 5rem;
  height: 100%;
`;
export const EmptyContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

export const EmptyTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const EmptyTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.1px;
  text-align: center;
`;

export const EmptySubtitle = styled.span`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 16px;
  max-width: 337px;
  font-weight: 400;
  letter-spacing: -0.08px;
`;

export const ReferralLinkContainer = styled.div`
  display: flex;

  align-items: center;
  gap: 16px;
`;

export const ReferralLink = styled.div`
  border-radius: 100px;
  border: 1px solid #3d68a9;
  background: linear-gradient(176deg, #05224f 3.6%, #0f4e9e 96.4%);
  box-shadow: 0 4px 24px 0 #081120;
  display: flex;
  padding: 12px 18px;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  text-decoration: underline;
  justify-content: center;

  border-radius: 100px;
  border: 1px solid #3d68a9;
  background: linear-gradient(176deg, #05224f 3.6%, #0f4e9e 96.4%);
  box-shadow: 0 4px 24px 0 #081120;

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const LightText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.08px;
  opacity: 0.2;
`;

export const CopyButton = styled.button`
  cursor: pointer;
  transition: all 0.3s ease;
  justify-content: center;
  font-family: Figtree;
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  background: #fff;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  @media (max-width: 450px) {
    align-self: flex-end;
  }
`;
